import React, { useCallback, useEffect, useState } from "react";
import "./Dashboard.css";
import {
  PopUPsomeOptions,
  Scrollx_animate,
  SmallStars,
  WavingHand,
  info,
  laptopScreenV3,
} from "../../assets/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjectsByPagination } from "../../Redux/actions/projectsActions";
import {
  createProject,
  deleteAProject,
  createAGoogleProject,
  renameProject,
  updateProjectStatus,
} from "../../Redux/actions/projectActions";
import {
  skipUserModel,
  allTemplatesList,
  getCurrentPlan,
} from "../../Redux/actions/commonActtion";
import {
  AiOutlineDelete,
  AiOutlineSortDescending,
  AiOutlineSortAscending,
} from "react-icons/ai";
import { FaChevronLeft, FaClone } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { SiGooglesheets } from "react-icons/si";
import { toast } from "react-toastify";
import { read, utils } from "xlsx";

import { NavBar } from "../../UiComponents/index";
import { excelDataToProjectData } from "../../services/excelDataToProjectData";
import CloneProjectModal from "../ProjectV2/CloneProject/CloneProjectModal";
import UserInputModal from "./userInputModal";
import { Loader, Button, Dropdown_Status, Loader2 } from "../../Components";
import SuccessModal from "./SuccessModal";
import Templates from "./Templates";
import ScrollTemp from "./ScrollTemp";
import "./PopUp.css";
import { FaChevronRight } from "react-icons/fa";
import { LuLoader2 } from "react-icons/lu";
import ProjectSkeleton from "../../Components/SkeletonLoader/ProjectSkeleton";

export default function Dashboard(setIsPreviewOpen) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dateSort, setDateSort] = useState("desc");
  const [isNoticeDisplay, setIsNoticeDisplay] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [newProjectInputModalOpen, setNewProjectInputModalOpen] =
    useState(false);
  const [projectName, setProjectName] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadOnClone, setLoadOnClone] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [cloneMsg, setCloneMsg] = useState(false);
  const [allprojectloading, setAllProjectLoading] = useState(false);
  const [production, setProduction] = useState(false);
  const [template, setTemplate] = useState(false);
  const [templateId, setTemplateId] = useState(0);
  const [projectIdForClone, seProjectIdForClone] = useState("");
  const [renameModal, setRenameModal] = useState({
    id: "",
    isOpen: false,
    title: "",
  });

  const [options, setOptions] = useState([
    { label: "No Status", value: "defaultStatusClass" },
    { label: "Approved", value: "approvedClass" },
    { label: "In Progress", value: "inProgressClass" },
    { label: "Need Review", value: "needsReviewClass" },
  ]);
  const [size, setSize] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  });

  const getStorageData = JSON.parse(localStorage.getItem("skipModels"));
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(
    getStorageData ? getStorageData.dashModalStatus : true
  );
  const [isPopupOne, setIsPopupOne] = useState(false);
  const [isPopupsecond, setIsPopupsecond] = useState(false);
  const [isPopupThird, setIsPopupThird] = useState(false);
  // const [isPopupFour, setIsPopupFour] = useState(false);
  const [createProjectRes, setCreateProjectRes] = useState();
  const [pageNo, setPageNo] = useState(1);
  const [allTemplateLoading, setAllTemplateLoading] = useState(false);

  const skipModel = () => {
    dispatch(
      skipUserModel({ dashModalStatus: false, layoutModalstatus: true })
    );
    setIsWelcomeModalOpen(false);
    localStorage.setItem(
      "skipModels",
      JSON.stringify({ dashModalStatus: false, layoutModalstatus: true })
    );
    setIsWelcomeModalOpen(false);
    setIsPopupOne(false);
    setIsPopupsecond(false);
    setIsPopupThird(false);
  };

  const nextToContinue = (key, val) => {
    if (key === "getStarted") {
      setIsWelcomeModalOpen(false);
      setIsPopupOne(true);
    } else if (key === "popupFirst") {
      setIsWelcomeModalOpen(false);
      setIsPopupOne(false);
      setIsPopupsecond(true);
    } else if (key === "popupSecond") {
      setIsPopupsecond(false);
      setIsPopupThird(true);
    } else if (key === "popupThird") {
      setIsPopupThird(false);
      // setIsPopupFour(true);
    }
  };

  let { projects, totalProjects } = useSelector((state) => state?.projects);
  let projectLoadingInOnePage = window.innerWidth > 2500 ? 15 : 8;
  let totalPages = Math.ceil(totalProjects / projectLoadingInOnePage);

  const templatesList = useSelector(
    (state) => state?.commonReducer?.templates?.data
  );

  const sortByDate = (sortType) => {
    setDateSort(sortType);
    projects = projects.sort((a, b) => {
      if (sortType === "asc")
        return new Date(a.createdAt) - new Date(b.createdAt);
      else return new Date(b.createdAt) - new Date(a.createdAt);
    });
  };

  useEffect(
    (dateSort) => {
      sortByDate(dateSort);
    },
    [projects, setDateSort]
  );

  const detectSize = () => {
    setSize({ winWidth: window.innerWidth, winHeight: window.innerHeight });
  };
  useEffect(() => {
    window.addEventListener("resize", detectSize);
    return () => {
      window.removeEventListener("resize", detectSize);
    };
  }, [size]);

  const handleChangeStatus = (index, value, project_id) => {
    const idx = options.findIndex((opt) => opt.value === value);
    dispatch(updateProjectStatus(project_id, value, idx));
  };

  const getAllProject = () => {
    setAllProjectLoading(true);
    dispatch(getCurrentPlan());
    dispatch(
      getProjectsByPagination("", projectLoadingInOnePage, pageNo, "")
    ).then(() => {
      setAllProjectLoading(false);
    });
  };

  const getAllTemplates = () => {
    setAllTemplateLoading(true);
    dispatch(allTemplatesList()).then(() => {
      setAllTemplateLoading(false);
    });
  };

  const increment = () => {
    setPageNo(pageNo < totalPages ? pageNo + 1 : pageNo);
  };

  const decrement = () => {
    setPageNo(pageNo > 1 ? pageNo - 1 : pageNo);
  };

  useEffect(() => {
    getAllProject();
    if (window.location.href.endsWith("dashboard")) {
      document.getElementById("navbar_0")?.classList?.remove("hidden");
    }
  }, [pageNo]);

  useEffect(() => {
    getAllTemplates();
  }, []);

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const fileNameWithoutExt = file.name.split(".").slice(0, -1).join(".");
        const projectData = excelDataToProjectData(
          fileNameWithoutExt,
          jsonData
        );
        dispatch(createProject(projectData));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      console.log(err);
    }
  };

  const handleGoogleProjectCreateButtonClick = async () => {
    try {
      if (projectName) {
        await setLoading(true);
        const res = await dispatch(
          createAGoogleProject(projectName, templateId)
        );
        setCreateProjectRes(res?.success);
        if (res?.success) {
          setNewProjectInputModalOpen(false);
          await setLoading(false);
          setProjectName("");
          setSuccessModal(true);
        } else {
          await setLoading(false);
          toast.error("Something Is Wrong");
          setProjectName("");
        }
      }
    } catch (err) {
      await setLoading(false);
    }
  };

  const navigateToProject = (projectId) => {
    navigate(`/dashboard/${projectId}`);
  };

  const deleteProject = (projectId, projectName) => {
    const confirm = window.confirm(
      `Are you sure! You want to delete project (${projectName})?`
    );
    if (confirm) dispatch(deleteAProject(projectId));
  };

  const handleNewProjectName = async () => {
    if (projectName) {
      await setNewProjectInputModalOpen(false);
      handleGoogleProjectCreateButtonClick();
    }
  };

  const handleRenameProjec = async () => {
    const res = await dispatch(
      renameProject(renameModal?.id, renameModal?.title)
    );
    if (res?.success) {
      setRenameModal((prev) => ({
        ...prev,
        isOpen: false,
        title: "",
        id: "",
      }));
      toast.success(res?.message);
    } else {
      toast.error("!Oops Something Is Wrong");
    }
  };

  const skeletonComponent = () => {
    let skeletonArr = [];
    let lastPageSkeleton = totalProjects % projectLoadingInOnePage;
    let noOfSkeleton =
      totalPages === pageNo ? lastPageSkeleton : projectLoadingInOnePage;
    for (let i = 0; i < noOfSkeleton; i++) {
      skeletonArr.push(<ProjectSkeleton key={i} />);
    }
    return skeletonArr;
  };
  return (
    <>
      {loadOnClone ? (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="140px"
            height="140px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Duplicating Project...</p>
        </div>
      ) : null}
      <div
        className={"tainer w-full h-full"}
        // isOpen={isWelcomeModalOpen}
        // onRequestClose={continueToHomeDashboard}
        contentLabel="Welcome Modal"
      >
        <div
          className="PopUPoneContainer"
          // isOpen={isWelcomeModalOpen}
          // onRequestClose={continueToHomeDashboard}
          contentLabel="Popup Modal"
        >
          {size.winWidth > 1000 ? (
            <div className={"w-full h-full dashContainer"}>
              <div className="projectHead dashHead">
                <NavBar />
              </div>

              <div className="main_dash_block dashBody">
                <div className="main_dash_div">
                  {(newProjectInputModalOpen || renameModal) && (
                    <UserInputModal
                      newProjectInputModalOpen={newProjectInputModalOpen}
                      setNewProjectInputModalOpen={setNewProjectInputModalOpen}
                      projectName={projectName}
                      setProjectName={setProjectName}
                      handleNewProjectName={handleNewProjectName}
                      renameModal={renameModal}
                      setRenameModal={setRenameModal}
                      handleRenameProjec={handleRenameProjec}
                    />
                  )}
                  {loading ? <Loader2 label={"Project Creating..."} /> : null}
                  {successModal && (
                    <SuccessModal
                      successModal={successModal}
                      setSuccessModal={setSuccessModal}
                      cloneMsg={cloneMsg}
                      setCloneMsg={setCloneMsg}
                    />
                  )}
                  {projectIdForClone && projectCloneModalOpen && (
                    <div className="">
                      <CloneProjectModal
                        projectCloneModalOpen={projectCloneModalOpen}
                        setProjectCloneModalOpen={setProjectCloneModalOpen}
                        projectId={projectIdForClone}
                        setCloneMsg={setCloneMsg}
                        setSuccessModal={setSuccessModal}
                        loading={loadOnClone}
                        setLoading={setLoadOnClone}
                      />
                    </div>
                  )}

 

                  <div className="DashBoardContainer w-full h-full px-[5%] ">
                    <div className="right_add_block">
                      <div className="right_heading_block  justify-between">
                        <div><h1 className="right_heading_text Syne pl-1 ">
                          Choose your new project
                        </h1>
                        </div>
                        <div className="">
                          <img
                            src={info}
                            alt=""
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(`/help/66f25db207e246eced9ecfda`)
                            }
                          />
                        </div>
                      </div>
                      <div className="right_add_block1">
                        {/* <EC_FileInput
                  accept=".xls,.xlsx"
                  label="+Blank"
                  handleFileInput={handleFileInput}
                /> */}

                        <div className="w-[100%] h-fit  snap_inline">
                          <ScrollTemp
                            template={template}
                            templatesList={templatesList}
                            setTemplate={setTemplate}
                            setTemplateId={setTemplateId}
                            setNewProjectInputModalOpen={
                              setNewProjectInputModalOpen
                            }
                            allTemplateLoading={allTemplateLoading}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="right_template_div ">
                      {/* <div className="right_template_block cursor-pointer ">
                  <button className="FontFamily-Avenir" onClick={() => { setTemplate(true) }}>+ See more templates</button>
                </div> */}
                    </div>

                    {/* Project Table List */}

                    <div className=" w-full pt-[30px]">
                      {/* <h1 className="right_heading_text  mb-2 Syne">
                        Your Projects
                      </h1> */}
                      <div className="w-full flex justify-center">
                        <div className="xl:w-[80%] 2xl:w-[w-70%]  h-16 flex justify-center w-[70%] items-center  ">
                          <div
                            // scope="col"
                            className="text-xl w-[30%]  font-medium text-white  text-left FontFamily-Avenir "
                          >
                            Project Name
                          </div>
                          <div
                            // scope="col"
                            className=" text-xl w-[22%] font-medium text-white  flex items-center justify-start  FontFamily-Avenir pl-[43px]"
                          >
                            Status
                          </div>

                          <div className="text-xl w-[23.3%] font-medium  text-white  text-center flex pl-[47px]">
                            <div className="text-center text-xl FontFamily-Avenir">
                              Created
                            </div>
                            <div
                              className=" cursor-pointer"
                              onClick={() =>
                                dateSort === "asc"
                                  ? sortByDate("desc")
                                  : sortByDate("asc")
                              }
                            >
                              {dateSort === "asc" ? (
                                <AiOutlineSortAscending />
                              ) : (
                                <AiOutlineSortDescending />
                              )}
                            </div>
                          </div>
                          <div className=" text-xl w-[23.3%] font-medium text-white  flex items-center justify-start  FontFamily-Avenir pl-[43px]">
                            Options                           
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Project Table List */}

                    <div className="flex  w-[100%]  h-[40%] projectTAble  justify-center  overflow-auto  ">
                      {/* <div className="  w-[100%]   "> */}
                      <div className="xl:w-[80%] 2xl:w-[w-70%] overflow-auto w-[80%] scroll_width1 ">
                        {allprojectloading ? (
                          <div className="w-[100%]">
                            {/* <LuLoader2 className="text-white text-[2rem] animate-spin m-auto mt-5"/> */}
                            {skeletonComponent()}
                          </div>
                        ) : projects && projects?.length ? (
                          projects?.map((project, index) => {
                            return project ? (
                              <div
                                className="white-80 w-[100%] justify-center text-lg cursor-pointer dashTable  flex items-center border-b-[1px] border-[#2d3e51]"
                                key={index}
                              >
                                {/* <div className="w-20  h-12 ps-3 text-sm font-medium white-80 flex items-center">
                          {idx + 1}
                        </div> */}

                                <div
                                  className="text-base text-left w-[30%]  capitalize white-80 FontFamily-Avenir-reg  h-12 flex items-center "
                                  onClick={() =>
                                    navigateToProject(project?._id)
                                  }
                                >
                                  {project?.title}
                                </div>
                                <div className="text-base  w-[22%] white-80 h-12 flex items-center justify-start ">
                                  <h1 className="">
                                    <Dropdown_Status
                                      options={options}
                                      value={
                                        project?.projectStatus === ""
                                          ? "No Status"
                                          : project?.projectStatus
                                      }
                                      projectStatus={project?.projectStatus}
                                      selectedID={project?.statusId}
                                      onChange={(value) => {
                                        handleChangeStatus(
                                          index,
                                          value,
                                          project?._id
                                        );
                                      }}
                                    />
                                  </h1>
                                </div>

                                <div className=" text-base white-80  w-[23.3%] h-12 text-left flex items-center FontFamily-Avenir-reg ">
                                  {new Date(project?.createdAt).toDateString()}{" "}
                                  -{" "}
                                  {new Date(project?.createdAt)
                                    .toTimeString()
                                    .slice(0, 8)}
                                </div>
                                <div className="flex w-[23.3%]">
                                  <div className="pr-3 edit">
                                    <span
                                      className=" cursor-pointer white-80"
                                      onClick={() =>
                                        setRenameModal((prev) => ({
                                          ...prev,
                                          isOpen: true,
                                          id: project?._id,
                                          title: project?.title,
                                        }))
                                      }
                                    >
                                      {/* <img className="mt-[4px] w-[25px]" src={Write} alt="" /> */}
                                      <MdOutlineDriveFileRenameOutline />
                                    </span>
                                  </div>
                                  <div className="clone">
                                    <div
                                      className="px-3 white-80"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setProjectCloneModalOpen(true);
                                        seProjectIdForClone(project?._id);
                                      }}
                                    >
                                      {/* <img className="w-[19px]" src={duplicate} alt="" /> */}

                                      <FaClone />
                                    </div>
                                  </div>

                                  <div className="px-3 sheet">
                                    <div className="flex  white-80 text-xl ">
                                      {project?.googleSheetLink ? (
                                        <span
                                          className="  cursor-pointer"
                                          onClick={() =>
                                            window.open(
                                              project?.googleSheetLink
                                            )
                                          }
                                        >
                                          {/* <img className="w-[10px]" src={dshCredit} alt="" /> */}

                                          <SiGooglesheets />
                                        </span>
                                      ) : project?.googleSpreadSheetId ? (
                                        <span
                                          className="mx-2 cursor-pointer white-80"
                                          onClick={() =>
                                            window.open(
                                              `https://docs.google.com/spreadsheets/d/${project?.googleSpreadSheetId}`
                                            )
                                          }
                                        >
                                          {/* <img className="w-[15px]" src={dshCredit} alt="" /> */}
                                          <SiGooglesheets />
                                        </span>
                                      ) : null}
                                    </div>
                                  </div>

                                  <div className="px-3 delete">
                                    <span
                                      className=" cursor-pointer white-80"
                                      onClick={() =>
                                        deleteProject(
                                          project?._id,
                                          project?.title
                                        )
                                      }
                                    >
                                      {/* <img className="w-[15px]" src={dshDelete} alt="" /> */}
                                      <AiOutlineDelete />
                                    </span>
                                  </div>
                                </div>

                                {/* <td>
                                  <span
                                    className="mx-2 cursor-pointer text-zink-600"
                                    onClick={() =>
                                      navigateToProject(project._id)
                                    }
                                  >
                                    <GrLinkNext/>
                                  </span>
                                </td> */}
                              </div>
                            ) : (
                              ""
                            );
                          })
                        ) : (
                          <tr>
                            <td>
                              <p className="all_project_loading">
                                No Data Found
                              </p>
                            </td>
                          </tr>
                        )}
                      </div>
                      {/* </div> */}
                    </div>
                    {totalProjects > projectLoadingInOnePage && (
                      <div className="paginationBox  Syne700  select-none text-white flex justify-center gap-[1rem]  items-center w-full">
                        <p
                          className="FontFamily-Avenir flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400"
                          onClick={decrement}
                        >
                          <FaChevronLeft />
                          prev
                        </p>
                        <p className="FontFamily-Avenir text-[0.8rem]">
                          {pageNo} / {totalPages}
                        </p>
                        <p
                          className="FontFamily-Avenir flex text-sm 3xl:text-base items-center cursor-pointer hover:text-gray-400"
                          onClick={increment}
                        >
                          next
                          <FaChevronRight onClick={increment} />
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="static  w-full overflow-hidden">
          <div className="w-full template_block overflow-hidden">
            <Templates
              template={template}
              templatesList={templatesList}
              setTemplate={setTemplate}
              setTemplateId={setTemplateId}
              setNewProjectInputModalOpen={setNewProjectInputModalOpen}
            />
          </div>
        </div> */}

                {/* <div className="copyright_block midnight-navy-200 ">
          <div className="copyright_div h-full flex items-center midnight-navy-100 drop-shadow-2xl">
            <h4 className="copyright_h4_one ml-2 ">c</h4>
            <h4 className=" white-80 ml-2">
              2022 Elements , All rights reserved
            </h4>
          </div>
          <div className="copyright_div_two ">
            <h4 className="copyright_div_two_h4 white-80">legal</h4>
          </div>
        </div> */}
              </div>
            </div>
          ) : (
            <div
              id="warning-messageas"
              style={{ width: "100%", height: "100%" }}
            >
              <div className="w-full h-full  LoginLeft-block md:flex md:flex-row flex flex-col-reverse justify-center items-center  ">
                <div className=" md:w-[55%] md:h-1/2 h-[35%]  flex justify-center items-center">
                  <div className="relative   text-white text-4xl flex flex-col justify-center items-center text-center">
                    <img
                      className="w-80 md:mt-[0px] mt-[-250px] z-10 fixed"
                      src={laptopScreenV3}
                      alt=""
                    />
                  </div>
                </div>
                <div className=" md:w-[45%] w-full md:h-full  h-[65%]   flex justify-center items-center bg-white">
                  <div className=" md:w-[85%] w-[90%]  h-1/2 flex flex-col justify-center items-center ">
                    <div className="flex flex-col justify-center items-center sm:mt-[0px] mt-[-35px] sm:px-[0px] px-[25px]">
                      <h1 className="text-black md:text-[26px] text-2xl  Syne700  pb-4 text-center">
                        Thanks for signing up!
                      </h1>
                      <h3 className="FontFamily-Avenir-reg text-base text-[#585858] py-[10px] text-center ">
                        We've sent you an email with some exciting details.
                      </h3>
                      <h3 className="FontFamily-Avenir-reg text-base text-[#585858] py-[10px] text-center ">
                        For the best experience, grab your laptop or desktop
                        because our app is not available on phones.
                      </h3>
                      <h3 className="FontFamily-Avenir-reg text-base text-[#585858] pt-[10px] text-center ">
                        Check your inbox and let the cinematic journey begin!
                        🎥✨
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* =================(5  SOME MORE OPTION'S HERE... POPUP)================= */}
          {/* <div className={isPopupFour === true ? "wmcOverlay" : "wmcOverlayNone"}></div>

          {isPopupFour && !allprojectloading == true && (
            <div className="PopUPfourContent ">
              <div className="text-white FontFamily-Avenir-reg">
                <div className="flex flex-col items-left justify-start px-3">
                  <h1 className="Syne700 font-bold text-[28px]  text-left  w-full py-3 capitalize PopUPContenth1"> Some more options here</h1>
                  <img className="pt-2 w-32 poplastimage" src={PopUPsomeOptions} alt="" />
                </div>

                <div className="pt-2 pr-[40px] flex items-center justify-end">
                  <button className="px-3 py-1 text-xl   welStartbtn rounded-2xl" onClick={skipModel}>Skip</button>
                </div>
              </div>
            </div>
          )} */}

          {/* ==================(4  YOUR PROJECT IS READY POPUP)================== */}
          <div
            className={
              isPopupThird === true ? "wmcOverlayNone" : "wmcOverlayNone"
            }
          ></div>

          {isPopupThird && !allprojectloading == true && (
            <div className="PopUPthirdContent">
              {/* <div className="triangle"></div> */}
              <div className="text-white FontFamily-Avenir-reg h-full">
                <div className="flex flex-col items-center justify-start px-3 h-[70%] cursor-default">
                  <h1 className="Syne700 font-bold text-[28px]  text-left w-full py-3 capitalize PopUPContenth1">
                    Your project is ready
                  </h1>
                  <p className="text-md text-left w-full PopUPContentP">
                    Your project is ready to edit and render.
                    <p className=""> Click the project when you are ready. </p>
                  </p>
                </div>
                <br />
                <div className="pt-4 flex items-center justify-center">
                  <div className="w-[155px] flex flex-row justify-between">
                    <button
                      className="px-3 py-1 text-[18px]    rounded-2xl"
                      onClick={skipModel}
                    >
                      Skip
                    </button>
                    <button
                      className="px-3 py-1 text-[18px] text-black  welStartbtn rounded-2xl"
                      onClick={skipModel}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ================(3  LET'S START WITH CUSTOM POPUP)================= */}
          <div
            className={
              isPopupsecond === true ? "wmcOverlayNone" : "wmcOverlayNone"
            }
          ></div>

          {isPopupsecond && (
            <div className="PopUPtwoContent">
              {/* <div className="triangle"></div> */}
              <div className="text-white FontFamily-Avenir-reg h-full mt-[0.4rem]">
                <div className="flex flex-col items-start justify-start px-4 h-[68%] cursor-default">
                  <h1 className="Syne700 font-bold text-[24px] text-left pt-[0.7rem] w-full capitalize PopUPContenth1">
                    Let’s start with New project
                  </h1>
                  <p className="text-md text-left PopUPContentP pt-3">
                    Let’s start with clicking on new project and{" "}
                    <span className="text-lg  text-left PopUPContentP yellow-50">
                      then click "Next".
                    </span>
                  </p>
                </div>
                <div className="pt-4  flex items-center justify-center">
                  <div className="w-[155px] flex flex-row justify-between">
                    <button
                      className="px-3 py-1 text-[18px]  rounded-2xl"
                      onClick={skipModel}
                    >
                      Skip
                    </button>
                    {createProjectRes ? (
                      <button
                        className="px-3 py-1 text-[18px] bold text-black welStartbtn rounded-2xl"
                        onClick={(val) => nextToContinue("popupSecond", val)}
                      >
                        Next
                      </button>
                    ) : (
                      <button className="px-3 py-1 text-[18px]  bold text-black welStartbtn rounded-2xl cursor-disable">
                        Next
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* =================(2  CREATE ANEW PROJECT POPUP)=================== */}
          <div
            className={isPopupOne === true ? "wmcOverlay" : "wmcOverlayNone"}
          ></div>

          {isPopupOne && (
            <div className="PopUPoneContent">
              <div className="text-white FontFamily-Avenir-reg ">
                <div className="flex flex-col items-center justify-start px-3 pb-[25px] cursor-default">
                  <h1 className="Syne700 font-bold text-[28px] text-left py-3 w-full capitalize PopUPContenth1">
                    Create a new project
                  </h1>
                  <p className="text-[1rem] text-left PopUPContentP">
                    To start creating end credits, choose any of the templates
                    above, or you can choose custom project.
                  </p>
                </div>
                <br />
                <div className="pt-4 flex items-center justify-center">
                  <div className="w-[155px] flex flex-row justify-between">
                    <button
                      className="px-3 py-1 text-[18px]    rounded-2xl"
                      onClick={skipModel}
                    >
                      Skip
                    </button>
                    <button
                      className="px-3 py-1 text-[18px] text-black  welStartbtn rounded-2xl"
                      onClick={(val) => nextToContinue("popupFirst", val)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ==================(1  WELCOME POPUP)==================== */}
          <div
            className={
              isWelcomeModalOpen === true ? "wmcOverlay" : "wmcOverlayNone"
            }
          ></div>

          {isWelcomeModalOpen && (
            <div
              className={
                size.winWidth < 1000 ? "hideComp" : "welcomeContent px-5"
              }
            >
              <div className="text-white FontFamily-Avenir-reg p-2">
                <div className="flex items-center justify-center cursor-default mr-4 gap-3">
                  <img
                    className="wavingHand w-12 mx-2"
                    src={WavingHand}
                    alt=""
                  />
                  <h1 className="Syne700 font-bold text-6xl welcomeH1 mr-7">
                    Welcome
                  </h1>
                </div>
                {/* <br /> */}
                {/* <div className="flex items-center justify-center">
                  <img className="w-6 mx-1" src={SmallStars} alt="" />
                  <p className="text-lg welcomep">We’re thrilled you are here!</p>
                </div> */}
                {/* <br /> */}
                <p className="text-[1rem] welcomep p-2 mt-3 cursor-default">
                  Start with a quick step-by-step walkthrough that will help{" "}
                  <br /> you create, edit and render end credits quickly.
                </p>
                <div className="p-2 ml-5 w-full flex align-center justify-center mt-[1.5rem]">
                  <button
                    className="px-3 py-[5px] text-xl  rounded-xl"
                    onClick={skipModel}
                  >
                    Skip
                  </button>

                  <button
                    className="px-3 py-[5px] text-xl mx-3 welStartbtn rounded-xl"
                    onClick={(val) => nextToContinue("getStarted", val)}
                  >
                    Get Started
                  </button>
                  {/* <button className="px-3 py-[5px] text-xl   POPnextbtn rounded-xl" onClick={skipModel}>Never show again</button> */}
                </div>
                {/* <div className="py-10 xl:py-5 w-full flex items-center justify-center text-white" >
                <button className="ml-16 px-3 py-[5px] text-xl   POPnextbtn rounded-xl" onClick={skipModel}>Skip</button>

                  <button className="px-3 py-[5px] text-xl mx-2  welStartbtn rounded-xl" onClick={(val) => nextToContinue('getStarted', val)}>
                    Get Started
                  </button>
                  <h1 className="px-3 py-[5px] text-xl   ">OR</h1>
                  <button className="px-3 py-[5px] text-xl   POPnextbtn rounded-xl" onClick={skipModel}>Never show</button>

                </div> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
